/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WhatsAppLinkResponse
 */
export interface WhatsAppLinkResponse {
  /**
   *
   * @type {string}
   * @memberof WhatsAppLinkResponse
   */
  state: WhatsAppLinkResponseStateEnum;
  /**
   *
   * @type {string}
   * @memberof WhatsAppLinkResponse
   */
  maskedSender?: string;
  /**
   *
   * @type {Date}
   * @memberof WhatsAppLinkResponse
   */
  expiresAt?: Date;
  /**
   *
   * @type {string}
   * @memberof WhatsAppLinkResponse
   */
  proofCommand?: string;
}

/**
 * @export
 */
export const WhatsAppLinkResponseStateEnum = {
  Pending: "pending",
  Prepared: "prepared",
  Proved: "proved",
  Confirmed: "confirmed",
  Canceled: "canceled",
  Expired: "expired",
  Unavailable: "unavailable",
} as const;
export type WhatsAppLinkResponseStateEnum =
  (typeof WhatsAppLinkResponseStateEnum)[keyof typeof WhatsAppLinkResponseStateEnum];

/**
 * Check if a given object implements the WhatsAppLinkResponse interface.
 */
export function instanceOfWhatsAppLinkResponse(
  value: object
): value is WhatsAppLinkResponse {
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function WhatsAppLinkResponseFromJSON(json: any): WhatsAppLinkResponse {
  return WhatsAppLinkResponseFromJSONTyped(json, false);
}

export function WhatsAppLinkResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WhatsAppLinkResponse {
  if (json == null) {
    return json;
  }
  return {
    state: json["state"],
    maskedSender:
      json["masked_sender"] == null ? undefined : json["masked_sender"],
    expiresAt:
      json["expires_at"] == null ? undefined : new Date(json["expires_at"]),
    proofCommand:
      json["proof_command"] == null ? undefined : json["proof_command"],
  };
}

export function WhatsAppLinkResponseToJSON(json: any): WhatsAppLinkResponse {
  return WhatsAppLinkResponseToJSONTyped(json, false);
}

export function WhatsAppLinkResponseToJSONTyped(
  value?: WhatsAppLinkResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    state: value["state"],
    masked_sender: value["maskedSender"],
    expires_at:
      value["expiresAt"] == null
        ? value["expiresAt"]
        : value["expiresAt"].toISOString(),
    proof_command: value["proofCommand"],
  };
}
